<template lang="pug">
.container.grid-lg
  load-manager(:status='status')
    .mt-2(v-if='current')
      .panel
        .panel-header.bg-gray.p-2
          .columns
            .column
              .h4 {{ 'cadastro' | tModel }}: nº #[span.text-bold {{ current.numero }}]
              .text-small.mt-2(v-if='current.contribuinte') {{ current.contribuinte.cpf_cnpj | cpfCnpj }} - {{ current.contribuinte.razao_social }}
            .column.col-auto
              div
                small {{ 'cadastro.tipo' | tModel }}
                div {{ current | enums('cadastro.tipo') }}
        .panel-nav
          .tab.tab-block
            li.tab-item
              router-link(:to='{ name: "app.osm.consultas.cadastros.show" }') Detalhes
            li.tab-item(v-if='current.cadastro_economico')
              router-link(
                :to='{ name: "app.osm.consultas.cadastros.show.economico" }'
              )
                | {{ 'cadastro.cadastro_economico' | tModel }}
            li.tab-item
              router-link.badge(
                :to='{ name: "app.osm.consultas.cadastros.show.socios" }',
                :data-badge='current.socios ? current.socios.length : 0'
              ) {{ 'cadastro.socios' | tModel }}
            li.tab-item
              router-link.badge(
                :to='{ name: "app.osm.consultas.cadastros.show.usuarios" }',
                :data-badge='current.usuarios_ativos ? current.usuarios_ativos.length : 0'
              ) Usuários
        .panel-body
          router-view
        .panel-footer
      .text-right
        router-link.btn.btn-link(
            :to="{ name: 'app.emailHistoricos', params: { scope: 'Cadastro', scope_id: current.id } }"
          )
            btn-content(name="E-mails", icon="fa fa-envelope-o")
        btn-logs(
          entityName='Cadastro',
          :entityId='current.id',
          v-acl:allowed.admin.logs.index
        )
        .btn.btn-link(
          @click='abrirOs',
          v-acl:allowed.admin.ordem_servicos.create
        )
          btn-content(name='Abrir OS', icon='fa fa-check-square-o')
        a.btn.btn-link(:href='current.url', target='_blank')
          btn-content(name='print')
</template>

<script>
import showMixin, { vuexDefaultMapping } from "@/mixins/show"

export default {
  vuex: { cadastros: vuexDefaultMapping },
  mixins: [showMixin],
  methods: {
    abrirOs() {
      this.$router.push({
        name: "app.osm.servicos.create",
        query: {
          cadastro_id: this.current.id,
        },
      })
    },
  },
}
</script>
